import { t } from '@lingui/core/macro';
import { OrderRecordCustomer } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { formatCurrencyAmount } from 'noddi-util';

interface Props {
  order: OrderRecordCustomer;
}

/** Quiet paid line for a prepaid booking's timeline, so no later step reads as a pending charge. */
export const PaidInAdvanceNote = ({ order }: Props) => (
  <p className='mb-2 flex items-center gap-1.5 text-sm text-muted-foreground'>
    <NoddiIcon name='Check' size='small' className='shrink-0 text-emerald-500' />
    {/* The order total, not `amountPaid`: that is net of refunds, which is not what the customer paid. */}
    {t`Paid in advance`} · {formatCurrencyAmount({ money: order.amountGross })}
  </p>
);
